module.exports = __webpack_public_path__ + "img/1550539295.989fc738.jpg";